import { render, staticRenderFns } from "./singleProbableGen.vue?vue&type=template&id=52f56668&scoped=true&"
import script from "./singleProbableGen.vue?vue&type=script&lang=js&"
export * from "./singleProbableGen.vue?vue&type=script&lang=js&"
import style0 from "./singleProbableGen.vue?vue&type=style&index=0&id=52f56668&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f56668",
  null
  
)

export default component.exports